export default "__VITE_ASSET__DupDRH3x__"